import script from "./DocTypeBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocTypeBadge.vue?vue&type=script&setup=true&lang=ts"

import "./DocTypeBadge.vue?vue&type=style&index=0&id=4b0382ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b0382ce"]])

export default __exports__